import { useEffect, useRef, useState } from 'react';
import Wrapper from '../global/Wrapper';
import mobileLogo from '../../assets/images/tbh/logo.svg';
import hamburgerIcon from '../../assets/images/tbh/hamburger.png';
import MobileRightNavigation from './MobileRightNavigation';
import { toggleBtn } from '../../features/navbarToggler/navbarSlice';
import { useDispatch, useSelector } from 'react-redux';

const MobileNav = ({ setIsOpen }: any) => {
  const isOpen = useSelector((state: any) => state.button.isOpen);
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(toggleBtn());
  };

  const hamMenuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const hamMenu = hamMenuRef.current;

    if (hamMenu) {
      const handleClick = () => {
        hamMenu.classList.toggle('active');
      };

      hamMenu.addEventListener('click', handleClick);

      return () => {
        hamMenu.removeEventListener('click', handleClick);
      };
    }
  }, []);

  return (
    <header className='z-50 py-[20px] bg-[#028789] px-[30px] md:z-0 fixed w-[100%] '>
      <Wrapper className='!mt-[0px]'>
        <nav className='flex justify-between items-center'>
          <div className='w-[164px] '>
            <img src={mobileLogo} alt='tbh-logo' className='w-full' />
          </div>
          <nav>
            <div ref={hamMenuRef} className='ham-menu' onClick={handleClick}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </nav>

          {isOpen && <MobileRightNavigation />}
        </nav>
      </Wrapper>
    </header>
  );
};

export default MobileNav;
